import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

import AuthShell from "../../Components/Common/AuthShell";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import Turnstile from "react-turnstile";
import { useBranding } from "../../Components/branding/Branding";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();
  const { isBrandingActive } = useBranding();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      if (!cfToken) {
        alert("Please complete the Cloudflare check");
        return;
      }
      dispatch(userForgetPassword({ id: values.email }));
    },
  });

  const { forgetError, forgetSuccessMsg } = useSelector((state) => ({
    forgetError: state.ForgetPassword.forgetError,
    forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  }));

  document.title = `Reset Password | ${isBrandingActive ? "CRMit - " : ""}Less Work. Do More.`;

  // password request success
  const { passwordResetRequestSuccessAPI } = useSelector((state) => ({
    passwordResetRequestSuccessAPI:
      state.ForgetPassword.passwordResetRequestSuccess,
  }));
  const [passwordResetRequestSuccess, setPasswordResetRequestSuccess] =
    useState(false);
  useEffect(() => {
    if (isEmpty(passwordResetRequestSuccessAPI)) return;
    if (passwordResetRequestSuccessAPI.status === 200) {
      validation.resetForm();
      toast.success(passwordResetRequestSuccessAPI.message);
      setPasswordResetRequestSuccess(true);
    } else {
      toast.error(passwordResetRequestSuccessAPI.message);
    }
  }, [passwordResetRequestSuccessAPI]);
  const sitekey = "0x4AAAAAAAhZMwfJAD7cG6kE"; // 🔁 Replace with your real sitekey
  const [cfToken, setCfToken] = useState(""); // ✅ Turnstile token

  return (
    <AuthShell
      heading="Forgot Password?"
      subheading="Enter your email and we'll send you reset instructions"
      below={
        <p className="mb-0">
          Wait, I remember my password...{" "}
          <Link to="/login">Click here</Link>
        </p>
      }
    >
      {passwordResetRequestSuccess ? (
        <div className="p-2">
          <p className="text-muted">
            Email sent to your email address. Please check your email it might
            take up to 5 minutes. Also please check your spam folder if you
            don't see the email in your inbox. If you still don't see the email
            please contact us
            {isBrandingActive &&
              " via Live Chat or email support@crmit.app"}
            , thank you.
          </p>
          <p className="text-muted">NOTE: You can now close this window.</p>
        </div>
      ) : (
        <div className="p-2">
          {forgetError && forgetError ? (
            <Alert color="danger" style={{ marginTop: "13px" }}>
              {forgetError}
            </Alert>
          ) : null}
          {forgetSuccessMsg ? (
            <Alert color="success" style={{ marginTop: "13px" }}>
              {forgetSuccessMsg}
            </Alert>
          ) : null}
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-4">
              <Label className="form-label">Email</Label>
              <Input
                name="email"
                className="form-control"
                placeholder="Enter email"
                type="email"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.email || ""}
                invalid={
                  validation.touched.email && validation.errors.email
                    ? true
                    : false
                }
              />
              {validation.touched.email && validation.errors.email ? (
                <FormFeedback type="invalid">
                  <div>{validation.errors.email}</div>
                </FormFeedback>
              ) : null}
            </div>
            <div className="mb-4">
              <Turnstile
                sitekey={sitekey}
                onVerify={(token) => setCfToken(token)}
                theme={"light"}
                refreshExpired={"auto"}
                size={"flexible"}
              />
            </div>

            <div className="text-center mt-4">
              <Button color="primary" className="w-100" type="submit">
                Send Reset Link
              </Button>
            </div>
          </Form>
        </div>
      )}
    </AuthShell>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
